export enum ConversationalTheme {
  'volume_management' = 'volume_management',
  'price_management' = 'price_management',
  'billing' = 'billing',
  'account_management' = 'account_management',
}
